(function () {
  'use strict';

  try {
    var banner = document.querySelector('[data-runit-cookie-banner]');
    if (!banner) return;

    var status = banner.querySelector('[data-runit-cookie-status]');
    var summary = banner.querySelector('[data-runit-cookie-summary]');
    var options = banner.querySelector('[data-runit-cookie-options]');
    var customise = banner.querySelector('[data-runit-cookie-customise]');
    var back = banner.querySelector('[data-runit-cookie-back]');
    var saleOption = banner.querySelector('[data-runit-sale-option]');
    var privacy = null;
    var opener = null;
    var core = window.RunItConsentCore;
    if (!core || typeof core.createConsentSync !== 'function') return;

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function loadAnalytics() {
      if (window.__runitPosthogLoaded === true) return;
      var marker = document.querySelector('[data-runit-posthog-bootstrap-src]');
      var src = marker && marker.getAttribute('data-runit-posthog-bootstrap-src');
      if (!src) return;
      window.__runitPosthogLoaded = true;
      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.onload = function () {
        document.dispatchEvent(new CustomEvent('runit:posthog-ready'));
      };
      script.onerror = function () {
        window.__runitPosthogLoaded = false;
      };
      document.head.appendChild(script);
    }

    function optOut(optionsArg) {
      try {
        if (window.posthog && typeof window.posthog.opt_out_capturing === 'function') {
          window.posthog.opt_out_capturing(optionsArg || { clear_persistence: true });
        }
      } catch (e) {
        /* never throw into storefront */
      }
    }

    var sync = core.createConsentSync({
      loadAnalytics: loadAnalytics,
      optOut: optOut
    });

    function applyConsent() {
      try {
        if (!privacy) return;
        var result = sync(
          privacy.currentVisitorConsent(),
          privacy.analyticsProcessingAllowed()
        );
        if (
          result === 'enabled' &&
          window.posthog &&
          typeof window.posthog.opt_in_capturing === 'function'
        ) {
          window.posthog.opt_in_capturing();
        }
      } catch (e) {
        /* never throw into storefront */
      }
    }

    /* Tell the overlay coordinator (assets/runit-overlays.js) what this banner
       is doing, so it never has to guess from the DOM whether a first-visit
       cookie question is coming. */
    function announce(name) {
      try {
        document.dispatchEvent(new CustomEvent(name));
      } catch (e) {
        /* never throw into storefront */
      }
    }

    /* The panel holds two views and shows one at a time: the one-sentence
       summary, or the optional-cookie switches. Opening the banner always
       starts on the summary, so a returning visitor re-decides from the
       compact state rather than landing inside the switches. */
    function showView(name) {
      var manage = name === 'options';
      if (summary) summary.hidden = manage;
      if (options) options.hidden = !manage;
      if (customise) customise.setAttribute('aria-expanded', manage ? 'true' : 'false');
    }

    function showBanner() {
      banner.hidden = false;
      showView('summary');
      announce('runit:cookie-open');
      if (!privacy) {
        setStatus('Loading your cookie preferences…');
        return;
      }
      setStatus('');
      try {
        var consent = privacy.currentVisitorConsent() || {};
        banner.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          input.checked = consent[input.name] === 'yes';
        });
        if (saleOption) {
          saleOption.hidden = typeof privacy.saleOfDataRegion === 'function'
            ? !privacy.saleOfDataRegion()
            : true;
        }
      } catch (e) {
        setStatus('Cookie preferences are unavailable. Please reload and try again.');
      }
    }

    function focusReturn() {
      if (opener && typeof opener.focus === 'function') {
        try {
          opener.focus();
        } catch (e) {
          /* ignore */
        }
      }
    }

    document.querySelectorAll('[data-runit-cookie-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        opener = button;
        showBanner();
        var first = banner.querySelector('button');
        if (first) first.focus();
      });
    });

    if (customise) {
      customise.addEventListener('click', function () {
        showView('options');
        var first = options && options.querySelector('input[type="checkbox"]');
        if (first) first.focus();
      });
    }

    if (back) {
      back.addEventListener('click', function () {
        showView('summary');
        if (customise) customise.focus();
      });
    }

    banner.querySelectorAll('[data-runit-consent]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!privacy) {
          setStatus('Cookie preferences are unavailable. Please reload and try again.');
          return;
        }
        var mode = button.getAttribute('data-runit-consent');
        var consent = {};
        ['analytics', 'marketing', 'preferences', 'sale_of_data'].forEach(function (name) {
          if (mode === 'custom') {
            var input = banner.querySelector('input[name="' + name + '"]');
            consent[name] = !!(input && input.checked);
          } else {
            consent[name] = mode === 'accept';
          }
        });
        var buttons = banner.querySelectorAll('button');
        buttons.forEach(function (item) {
          item.disabled = true;
        });
        privacy.setTrackingConsent(consent, function (error) {
          buttons.forEach(function (item) {
            item.disabled = false;
          });
          if (error) {
            setStatus('Could not save your choices. Please try again.');
            return;
          }
          banner.hidden = true;
          showView('summary');
          setStatus('');
          focusReturn();
          announce('runit:cookie-close');
        });
      });
    });

    function initialise() {
      try {
        if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
          setStatus('Cookie preferences are unavailable. Please reload and try again.');
          announce('runit:consent-ready');
          return;
        }
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          function (error) {
            try {
              if (error || !window.Shopify.customerPrivacy) {
                setStatus('Cookie preferences are unavailable. Please reload and try again.');
                announce('runit:consent-ready');
                return;
              }
              privacy = window.Shopify.customerPrivacy;
              applyConsent();
              document.addEventListener('visitorConsentCollected', applyConsent);
              var current = privacy.currentVisitorConsent() || {};
              var shouldShow =
                typeof privacy.shouldShowBanner === 'function' && privacy.shouldShowBanner();
              if (!banner.hidden || !current.analytics || shouldShow) {
                showBanner();
              }
            } catch (e) {
              setStatus('Cookie preferences are unavailable. Please reload and try again.');
            }
            /* The verdict is in — with or without a banner on screen. */
            announce('runit:consent-ready');
          }
        );
      } catch (e) {
        setStatus('Cookie preferences are unavailable. Please reload and try again.');
        announce('runit:consent-ready');
      }
    }

    if (document.readyState === 'complete') initialise();
    else window.addEventListener('load', initialise, { once: true });
  } catch (e) {
    /* consent failures must not affect commerce */
  }
})();
